import { usePaginatedQuery } from 'react-query';
import { listCenters } from 'src/services/api/catalogs';

function useListCentersCatalog(query, enabled = true) {
  return usePaginatedQuery(['centers', query], (key, query) => listCenters(query), { enabled });
}

export default useListCentersCatalog;
